import InputFrame from './index.container';

export default InputFrame;
export * from './index.types';
export * from './index.styles';
